import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from '@mui/material';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import {URGENCY} from '../../../../constants/Urgency';
import {recommendFieldsType} from '../recommendFields';

import {useRecommendContext} from '../CreateRecommendHelpers';
import {useAutoField, useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import AutoField, {ActionType} from '../../../../components/AutoForm/AutoFieldNew';
import {
  loadUrgencyDefaults,
  useLoadUrgencyDefaults,
  loadUrgencyFromRecommend,
  useLoadUrgencyFromRecommend,
} from '../../hooks/createRecommendHooks';

export {
  loadUrgencyDefaults,
  useLoadUrgencyDefaults,
  loadUrgencyFromRecommend,
  useLoadUrgencyFromRecommend,
};

export const URGENCY_OPTIONS = [
  {
    value: URGENCY.NORMAL_ID,
    label: 'Normal',
  },
  {
    value: URGENCY.TAX_ID,
    label: 'Tax year sensitive',
  },
  {
    value: URGENCY.URGENT_ID,
    label: 'Urgent',
  },
];

export const RecommendsUrgency: React.FC<{direction: 'row' | 'column'}> = ({
  direction,
}) => {
  // usually this will be the type, but not always
  // const {values, setFieldValue, errors} = useAutoForm<recommendFieldsType>();
  const [urgencyInput, urgencyMeta, urgencyHelpers] =
    useAutoField<recommendFieldsType['urgency']>('urgency');
  const [urgencyReasonInput, urgencyReasonMeta, urgencyReasonHelpers] =
    useAutoField<recommendFieldsType['urgencyReason']>('urgencyReason');

  const {value: urgencyValue} = urgencyInput;

  useLoadUrgencyDefaults();

  return (
    <>
      <Grid
        spacing={2}
        direction={direction}
        position="relative"
        alignItems={direction === 'row' ? 'center' : 'stretch'}
        container
      >
        <Grid item xs={direction === 'row' ? 6 : 12}>
          <AutoField
            field={{
              id: 'urgency',
              label: 'Urgency:',
              type: ActionType.radioGroup,
              options: URGENCY_OPTIONS,
            }}
          />
        </Grid>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          zIndex={1}
          position="absolute"
          top={25} // px
          right={0}
        >
          <Tooltip title="Urgency box should not be abused by Advisers, this should only be used in such cases as approaching tax year end.">
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Box>
        {urgencyValue === URGENCY.NORMAL_ID ? null : (
          <Grid item xs={direction === 'row' ? 6 : 12}>
            <FormControl disabled={urgencyValue === URGENCY.NORMAL_ID}>
              <AutoField
                field={{
                  id: 'urgencyReason',
                  label: 'Why is this urgent?',
                  type: ActionType.text,
                  disabled: urgencyValue === URGENCY.NORMAL_ID,
                  boldLabel: true,
                  fullWidth: true,
                }}
              />
            </FormControl>
          </Grid>
        )}
      </Grid>
    </>
  );
};

const RecommendWhenOptions: React.FC<{visible: boolean}> = (props) => {
  const {visible = true} = props;

  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();
  const {recommendDetails} = useRecommendContext();

  useLoadUrgencyFromRecommend();

  if (!visible) {
    return null;
  }

  if (values.isSppDa) {
    return null;
  }

  return <RecommendsUrgency direction="column" />;
};

export default RecommendWhenOptions;
